import React from "react";
import classNames from "lib/classNames";
import Icon from "./Icon";
import styles from "styles/tutorial.module.scss";

const GuideLink = ({ label, link = "" }) => {
  return (
    <div
      className={
        classNames("flex items-center justify-start mb-3") + " " + styles.link
      }
    >
      <Icon icon="link" color="#718096" />
      <a
        className={classNames("text-gray-600 text-sm ml-2")}
        style={{ lineHeight: "19px" }}
        href={link}
        target="_blank"
      >
        {label}
      </a>
    </div>
  );
};

export default GuideLink;
